import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {City} from '@models/city';
import {LabelType, Options} from '@angular-slider/ngx-slider';
import {CityParams, UserSearchCity} from '@models/search';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';
import {CommonService} from '@services/common.service';
import {CityService} from '@services/city.service';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import * as $ from 'jquery';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {OnboardingService} from '@services/onboarding.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';

@Component({
    selector: 'app-filters-city',
    templateUrl: './filters-city.component.html',
    styleUrls: ['./filters-city.component.scss']
})
export class FiltersCityComponent implements OnInit {

    searchForm: UntypedFormGroup;
    citiesSearch: City[] = [];
    mode = 'sidebar';

    options: Options = {
        floor: 0,
        ceil: 1000000,
        step: 10000,
        translate: (value: number, label: LabelType): string => {
            if (value === 1000000) {
                return '1 000 000 € et +';
            }
            return value + ' €';
        }
    };

    optionsPop: Options = {
        floor: 0,
        ceil: 150000,
        step: 1000,
        translate: (value: number, label: LabelType): string => {
            if (value === 150000) {
                return '150 000 hab et +';
            }
            return value + ' hab';
        }
    };

    optionsDistance: Options = {
        floor: 0,
        ceil: 100,
        step: 10,
        translate: (value: number, label: LabelType): string => {
            return value + ' km';
        }
    };

    optionsMv: Options = {
        floor: 0,
        ceil: 40000,
        translate: (value: number, label: LabelType): string => {
            if (value === 40000) {
                return '40 000 € et +';
            }
            return value + ' €';
        }
    };

    optionsTc: Options = {
        floor: 0,
        ceil: 30,
        translate: (value: number, label: LabelType): string => {
            if (value === 30) {
                return '30 % et +';
            }
            return value + ' %';
        }
    };

    optionsTe: Options = {
        floor: 0,
        ceil: 30,
        translate: (value: number, label: LabelType): string => {
            if (value === 30) {
                return '30 % et +';
            }
            return value + ' %';
        }
    };

    optionsTv: Options = {
        floor: 0,
        ceil: 30,
        translate: (value: number, label: LabelType): string => {
            if (value === 30) {
                return '30 % et +';
            }
            return value + ' %';
        }
    };

    optionsTl: Options = {
        floor: 0,
        ceil: 80,
        translate: (value: number, label: LabelType): string => {
            if (value === 80) {
                return '80 % et +';
            }
            return value + ' %';
        }
    };

    optionsTensiometre: Options = {
        floor: 0,
        ceil: 8,
        translate: (value: number, label: LabelType): string => {
            if (value === 0) {
                return 'Très facile';
            } else if (value === 1) {
                return 'Moy facile';
            } else if (value === 2) {
                return 'Facile';
            } else if (value === 3) {
                return 'Normal';
            } else if (value === 4) {
                return 'Normal';
            } else if (value === 5) {
                return 'Normal';
            } else if (value === 6) {
                return 'Difficile';
            } else if (value === 7) {
                return 'Moy difficile';
            } else if (value === 8) {
                return 'Très difficile';
            }
            return '';
        }
    };

    optionsSquarePriceCity: Options = {
        floor: 0,
        ceil: 10000,
        step: 100,
        translate: (value: number, label: LabelType): string => {
            if (value === 10000) {
                return '10000 €/m² et +';
            }
            return value + ' €/m²';
        }
    };

    optionsEfficiencyCity: Options = {
        floor: 0,
        ceil: 10,
        step: 0.5,
        translate: (value: number, label: LabelType): string => {
            if (value === 10) {
                return '10 % et +';
            }
            return value + ' %';
        }
    };

    optionsPriceEvolCity: Options = {
        floor: -100,
        ceil: 100,
        step: 5,
        translate: (value: number, label: LabelType): string => {
            if (value === 100) {
                return '100 % et +';
            } else if (value === -100) {
                return '- 100 % et -';
            }
            return value + ' %';
        }
    };

    optionsSquareRent: Options = {
        floor: 0,
        ceil: 50,
        translate: (value: number, label: LabelType): string => {
            if (value === 50) {
                return '50 €/m² et +';
            }
            return value + ' €/m²';
        }
    };

    zipCode: City[] = [];
    cities_include: City[] = [];
    cities_exclude: City[] = [];
    params;

    // region: [
    //     {
    //         name: 'Auvergne-Rhône-Alpes',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Bourgogne-Franche-Comté',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Bretagne',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Centre-Val de Loire',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Corse',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Grand Est',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Guadeloupe',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Guyane',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Hauts-de-France',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Ile-de-France',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'La Réunion',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Martinique',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Mayotte',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Normandie',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Nouvelle-Aquitaine',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Occitanie',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Pays de la Loire',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    //     {
    //         name: 'Provence-Alpes-Côte d\'Azur',
    //         completed: false,
    //         subtasks: [
    //             { name: 'Primary', completed: false },
    //         ],
    //     },
    // ];

    currentSearch: UserSearchCity;
    userSearchs: UserSearchCity[] = [];
    currentTab = 'city_include';

    constructor(
        private adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        public commonService: CommonService,
        public cityService: CityService,
        public onboardingService: OnboardingService,
        public dialog: MatDialog,
        private location: Location,
        private http: HttpClient,
        private route: ActivatedRoute,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.params = {'id': ''};
        if (this.authenticationService.isLogin) {
            this.adService.getUserSearchCity().subscribe(r => {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs = r;
                }
                this.setParams();
                this.setSearch();
            });
        } else {
            this.setParams();
        }
        this.setSearchForm();
        this.onboardingService.listen().subscribe(elem => {

        });
        if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.ville.status == 'not_started') {
            this.onboardingService.startVille().subscribe();
        }
    }

    setParams() {
        this.route.params.subscribe(params => {
            this.params = params;
            if (params.id !== undefined) {
                if (params.id == 'result') {
                    this.userService.getCurrentSearchCity().subscribe(params => {
                        this.currentSearch = params;
                        this.setSearchForm(); // Set values in BDD
                        this.currentSearch.search_city_params = this.getSearchParams(); // Get all value and default value if missing on DB
                        this.setSearchForm(); // Set again with all fields
                    });
                } else {
                    this.setSearch();
                }
            }
        });
    }

    setSearch() {
        if (this.params.id !== undefined && this.userSearchs.length > 0) {
            if (this.authenticationService.isAllowed('essentiel')) {
                this.userSearchs.forEach(f => {
                    if (f.id === parseInt(this.params.id, 10)) {
                        this.currentSearch = f;
                        this.setSearchForm(); // Set values in BDD
                        this.currentSearch.search_city_params = this.getSearchParams(); // Get all value and default value if missing on DB
                        this.setSearchForm(); // Set again with all fields
                    }
                });
            } else {
                this.alertService.error('Cette fonctionnalité néccessite un plan supérieur, consultez nos forfaits dans Mon comptes > Nos forfaits');
            }
        }
    }

    setSearchForm() {
        const unlock = this.authenticationService.isAllowed('essentiel');

        this.optionsPop.disabled = !unlock;
        this.optionsMv.disabled = !unlock;
        this.optionsTe.disabled = !unlock;
        this.optionsTv.disabled = !unlock;
        this.optionsTl.disabled = !unlock;
        this.optionsTc.disabled = false;
        this.optionsTensiometre.disabled = !unlock;
        this.optionsSquarePriceCity.disabled = !unlock;
        this.optionsSquareRent.disabled = !unlock;
        this.optionsEfficiencyCity.disabled = !unlock;
        this.optionsPriceEvolCity.disabled = !unlock;

        this.searchForm = new UntypedFormGroup({
            //  exclude_cities: new UntypedFormControl({
            //     value: this.currentSearch ? this.currentSearch.search_city_params.exclude_cities : null,
            //     disabled: !unlock
            // }),
            cityIncludeControl: new UntypedFormControl({value: null}),
            cityExcludeControl: new UntypedFormControl({value: null}),
            region: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.region != null && this.currentSearch.search_city_params.region.length ? this.currentSearch.search_city_params.region : null,
                disabled: !unlock
            }),
            departement: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.departement != null && this.currentSearch.search_city_params.departement.length ? this.currentSearch.search_city_params.departement : null,
                disabled: !unlock
            }),
            evol_demo: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.evol_demo != null && this.currentSearch.search_city_params.evol_demo.length ? this.currentSearch.search_city_params.evol_demo : null,
                disabled: !unlock
            }),
            pop: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.pop != null && this.currentSearch.search_city_params.pop.length ? this.currentSearch.search_city_params.pop : null,
                disabled: this.optionsPop.disabled
            }),
            mv: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.mv != null && this.currentSearch.search_city_params.mv.length ? this.currentSearch.search_city_params.mv : null,
                disabled: this.optionsMv.disabled
            }),
            tc: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.tc != null && this.currentSearch.search_city_params.tc.length ? this.currentSearch.search_city_params.tc : null,
                disabled: this.optionsTc.disabled
            }),
            te: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.te != null && this.currentSearch.search_city_params.te.length ? this.currentSearch.search_city_params.te : null,
                disabled: this.optionsTe.disabled
            }),
            tv: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.tv != null && this.currentSearch.search_city_params.tv.length ? this.currentSearch.search_city_params.tv : null,
                disabled:  this.optionsTv.disabled
            }),
            tl: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.tl != null && this.currentSearch.search_city_params.tl.length ? this.currentSearch.search_city_params.tl : null,
                disabled: this.optionsTl.disabled
            }),
            squarePriceCity: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.squarePriceCity != null && this.currentSearch.search_city_params.squarePriceCity.length ? this.currentSearch.search_city_params.squarePriceCity : null,
                disabled: this.optionsSquarePriceCity.disabled
            }),
            efficiencyCity: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.efficiencyCity != null && this.currentSearch.search_city_params.efficiencyCity.length ? this.currentSearch.search_city_params.efficiencyCity : null,
                disabled:  this.optionsEfficiencyCity.disabled
            }),
            priceEvolCity_1: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.priceEvolCity_1 != null && this.currentSearch.search_city_params.priceEvolCity_1.length ? this.currentSearch.search_city_params.priceEvolCity_1 : null,
                disabled: this.optionsPriceEvolCity.disabled
            }),
            priceEvolCity_3: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.priceEvolCity_3 != null && this.currentSearch.search_city_params.priceEvolCity_3.length ? this.currentSearch.search_city_params.priceEvolCity_3 : null,
                disabled: this.optionsPriceEvolCity.disabled
            }),
            priceEvolCity_5: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.priceEvolCity_5 != null && this.currentSearch.search_city_params.priceEvolCity_5.length ? this.currentSearch.search_city_params.priceEvolCity_5 : null,
                disabled: this.optionsPriceEvolCity.disabled
            }),
            squareRent: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.squareRent != null && this.currentSearch.search_city_params.squareRent.length ? this.currentSearch.search_city_params.squareRent : null,
                disabled: this.optionsSquareRent.disabled
            }),
            tensiometre: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_city_params.tensiometre != null && this.currentSearch.search_city_params.tensiometre.length ? this.currentSearch.search_city_params.tensiometre : null,
                disabled: this.optionsTensiometre.disabled
            }),
            coeur_de_ville: new UntypedFormControl({
                value: this.currentSearch ? this.currentSearch.search_city_params.coeur_de_ville : null,
                disabled: !unlock
            }),
            denormandie: new UntypedFormControl({
                value: this.currentSearch ? this.currentSearch.search_city_params.denormandie : null,
                disabled: !unlock
            }),
        });

        this.cities_include = this.currentSearch && this.currentSearch.search_city_params.cities_include ? this.currentSearch.search_city_params.cities_include : [];
        this.cities_exclude = this.currentSearch && this.currentSearch.search_city_params.cities_exclude ? this.currentSearch.search_city_params.cities_exclude : [];

        this.searchForm.get('cityIncludeControl').valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                switchMap(value => this.cityService.search(this.searchForm.get('cityIncludeControl').value))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.zipCode = d;
            });

        this.searchForm.get('cityExcludeControl').valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                switchMap(value => this.cityService.search(this.searchForm.get('cityExcludeControl').value))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.zipCode = d;
            });
        this.loadCities();
    }

    unlock() {
        const dialogRef = this.dialog.open(UpgradePlanV2Component, {
            width: '520px',
            data: {visuel: 'assets/upgrade/map-city-search.png', plan: 'Essentiel', feature: 'Recherche des villes rentables'}
        });
    }

    loadCities() {
        const params = this.getSearchParams();

        this.adService.searchCities(params).subscribe(res => {
            this.citiesSearch = res;
        }, error => {
            this.alertService.error('Une erreur est survenue');
            console.log(error);
        });
    }

    getSearchParams(): CityParams {
        const cities_include = [];
        this.cities_include.forEach(c => {
            cities_include.push(c);
        });

        const cities_exclude = [];
        this.cities_exclude.forEach(c => {
            cities_exclude.push(c);
        });

        return {
            // exclude_cities: this.searchForm.get('exclude_cities').value || false,
            region: this.searchForm.get('region').value || [],
            departement: this.searchForm.get('departement').value || [],
            evol_demo: this.searchForm.get('evol_demo').value || [],
            pop: this.searchForm.get('pop').value || [this.optionsPop.floor, this.optionsPop.ceil],
            tc: this.searchForm.get('tc').value || [this.optionsTc.floor, this.optionsTc.ceil],
            te: this.searchForm.get('te').value || [this.optionsTe.floor, this.optionsTe.ceil],
            tv: this.searchForm.get('tv').value || [this.optionsTv.floor, this.optionsTv.ceil],
            mv: this.searchForm.get('mv').value || [this.optionsMv.floor, this.optionsMv.ceil],
            tl: this.searchForm.get('tl').value || [this.optionsTl.floor, this.optionsTl.ceil],
            coeur_de_ville: this.searchForm.get('coeur_de_ville').value || false,
            denormandie: this.searchForm.get('denormandie').value || false,
            squareRent: this.searchForm.get('squareRent').value || [this.optionsSquareRent.floor, this.optionsSquareRent.ceil],
            tensiometre: this.searchForm.get('tensiometre').value || [this.optionsTensiometre.floor, this.optionsTensiometre.ceil],
            squarePriceCity: this.searchForm.get('squarePriceCity').value ||
                [this.optionsSquarePriceCity.floor, this.optionsSquarePriceCity.ceil],
            efficiencyCity: this.searchForm.get('efficiencyCity').value ||
                [this.optionsEfficiencyCity.floor, this.optionsEfficiencyCity.ceil],
            priceEvolCity_1: this.searchForm.get('priceEvolCity_1').value ||
                [this.optionsPriceEvolCity.floor, this.optionsPriceEvolCity.ceil],
            priceEvolCity_3: this.searchForm.get('priceEvolCity_3').value ||
                [this.optionsPriceEvolCity.floor, this.optionsPriceEvolCity.ceil],
            priceEvolCity_5: this.searchForm.get('priceEvolCity_5').value ||
                [this.optionsPriceEvolCity.floor, this.optionsPriceEvolCity.ceil],
            cities_include,
            cities_exclude,
        };
    }

    addCity(value, mode) {
        value.km = 0;
        if (mode == 'include') {
            this.cities_include.push(value);
            this.searchForm.get('cityIncludeControl').setValue('');
        } else {
            this.cities_exclude.push(value);
            this.searchForm.get('cityExcludeControl').setValue('');
        }
        this.loadCities();
    }

    removeCity(value, mode) {
        if (mode == 'include') {
            const index = this.cities_include.indexOf(value, 0);
            if (index > -1) {
                this.cities_include.splice(index, 1);
            }
        } else {
            const index = this.cities_exclude.indexOf(value, 0);
            if (index > -1) {
                this.cities_exclude.splice(index, 1);
            }
        }
        this.loadCities();
    }

    search() {
        this.currentSearch.search_city_params = this.getSearchParams();
        this.onboardingService.endVille(1, 1);
        if (this.params.id != 'result') {
            this.adService.editUserSearchCity(this.currentSearch).subscribe((us) => {
                this.router.navigate(['/app/city', this.params.id]);
            });
        } else {
            this.userService.setCurrentSearchCity(this.currentSearch);
            this.router.navigate(['/app/city/result']);
        }
    }

    cancel() {
        this.router.navigate(['/app/city/', this.params.id]);
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            maxWidth: '100%',
            data: {video: 'city_search'}
        });
    }
}
